/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_forgot_password_success = /** @type {(inputs: { email: NonNullable<unknown> }) => string} */ (i) => {
	return `Pokud existuje účet spojený s adresou ${i.email}, obdržíte e-mail s odkazem na obnovení hesla.`
};

const da_account_forgot_password_success = /** @type {(inputs: { email: NonNullable<unknown> }) => string} */ (i) => {
	return `Hvis der findes en konto tilknyttet ${i.email}, modtager du en email med et link til at nulstille din adgangskode.`
};

const de_account_forgot_password_success = /** @type {(inputs: { email: NonNullable<unknown> }) => string} */ (i) => {
	return `Wenn ein Konto mit der Adresse ${i.email} existiert, erhalten Sie eine E-Mail mit einem Link zum Zurücksetzen Ihres Passworts.`
};

const en_account_forgot_password_success = /** @type {(inputs: { email: NonNullable<unknown> }) => string} */ (i) => {
	return `If there is an account associated with ${i.email} you will receive an email with a link to reset your password.`
};

const es_account_forgot_password_success = /** @type {(inputs: { email: NonNullable<unknown> }) => string} */ (i) => {
	return `Si hay una cuenta asociada a la dirección ${i.email}, recibirás un correo con un enlace para restablecer tu contraseña.`
};

const fr_account_forgot_password_success = /** @type {(inputs: { email: NonNullable<unknown> }) => string} */ (i) => {
	return `S'il y a un compte associé à l'adresse ${i.email}, vous recevrez un email avec un lien pour réinitialiser votre mot de passe.`
};

const hu_account_forgot_password_success = /** @type {(inputs: { email: NonNullable<unknown> }) => string} */ (i) => {
	return `Ha van fiók ehhez az e-mail címhez, akkor jelszó-visszaállítási linket fog kapni.`
};

const it_account_forgot_password_success = /** @type {(inputs: { email: NonNullable<unknown> }) => string} */ (i) => {
	return `Se esiste un account associato a ${i.email}, riceverai una email con il link per reimpostare la password.`
};

const nl_account_forgot_password_success = /** @type {(inputs: { email: NonNullable<unknown> }) => string} */ (i) => {
	return `Als er een account is gekoppeld aan ${i.email}, ontvang je een e-mail met een link om je wachtwoord te resetten.`
};

const pl_account_forgot_password_success = /** @type {(inputs: { email: NonNullable<unknown> }) => string} */ (i) => {
	return `Jeśli istnieje konto powiązane z adresem ${i.email}, otrzymasz e-mail z linkiem do zresetowania hasła.`
};

const pt_account_forgot_password_success = /** @type {(inputs: { email: NonNullable<unknown> }) => string} */ (i) => {
	return `Se houver uma conta associada ao endereço ${i.email}, você receberá um e-mail com um link para redefinir sua senha.`
};

const sv_account_forgot_password_success = /** @type {(inputs: { email: NonNullable<unknown> }) => string} */ (i) => {
	return `Om det finns ett konto kopplat till ${i.email} får du ett e-postmeddelande med en återställningslänk.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ email: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_forgot_password_success = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_forgot_password_success(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_forgot_password_success", locale)
	if (locale === "cs") return cs_account_forgot_password_success(inputs)
	if (locale === "da") return da_account_forgot_password_success(inputs)
	if (locale === "de") return de_account_forgot_password_success(inputs)
	if (locale === "en") return en_account_forgot_password_success(inputs)
	if (locale === "es") return es_account_forgot_password_success(inputs)
	if (locale === "fr") return fr_account_forgot_password_success(inputs)
	if (locale === "hu") return hu_account_forgot_password_success(inputs)
	if (locale === "it") return it_account_forgot_password_success(inputs)
	if (locale === "nl") return nl_account_forgot_password_success(inputs)
	if (locale === "pl") return pl_account_forgot_password_success(inputs)
	if (locale === "pt") return pt_account_forgot_password_success(inputs)
	return sv_account_forgot_password_success(inputs)
};
export { account_forgot_password_success as "account.forgot_password_success" }